import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { ExplorePage } from './pages/ExplorePage';
import { AllPlacesPage } from './pages/AllPlacesPage';
import { PlaceDetailPage } from './pages/PlaceDetailPage';
import { PlanVisitPage } from './pages/PlanVisitPage';
import { LocalInsightsPage } from './pages/LocalInsightsPage';
import { ExperiencesPage } from './pages/ExperiencesPage';
import { CuisinePage } from './pages/CuisinePage';
import { AboutNairobiPage } from './pages/AboutNairobiPage';
import { NeighborhoodsPage } from './pages/NeighborhoodsPage';
import { NeighborhoodDetailPage } from './pages/NeighborhoodDetailPage';
import { WildlifeNaturePage } from './pages/WildlifeNaturePage';
import { ShoppingMarketsPage } from './pages/ShoppingMarketsPage';
import { CultureHistoryPage } from './pages/CultureHistoryPage';
import { EconomyInnovationPage } from './pages/EconomyInnovationPage';
import { EventsPage } from './pages/EventsPage';
import { EventDetailPage } from './pages/EventDetailPage';
import { HotelsPage } from './pages/HotelsPage';
import { LandmarksPage } from './pages/LandmarksPage';
import { FestivalsPage } from './pages/FestivalsPage';
import { NightlifePage } from './pages/NightlifePage';
function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen" data-id="element-1">
        <Navigation data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<ExplorePage data-id="element-5" />} data-id="element-4" />
          <Route path="/places" element={<AllPlacesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/place/:id" element={<PlaceDetailPage data-id="element-9" />} data-id="element-8" />
          <Route path="/plan" element={<PlanVisitPage data-id="element-11" />} data-id="element-10" />
          <Route path="/insights" element={<LocalInsightsPage data-id="element-13" />} data-id="element-12" />
          <Route path="/experiences" element={<ExperiencesPage data-id="element-15" />} data-id="element-14" />
          <Route path="/cuisine" element={<CuisinePage data-id="element-17" />} data-id="element-16" />
          <Route path="/nightlife" element={<NightlifePage data-id="element-19" />} data-id="element-18" />
          <Route path="/about-nairobi" element={<AboutNairobiPage data-id="element-21" />} data-id="element-20" />
          <Route path="/neighborhoods" element={<NeighborhoodsPage data-id="element-23" />} data-id="element-22" />
          <Route path="/neighborhood/:id" element={<NeighborhoodDetailPage data-id="element-25" />} data-id="element-24" />
          <Route path="/wildlife-nature" element={<WildlifeNaturePage data-id="element-27" />} data-id="element-26" />
          <Route path="/shopping-markets" element={<ShoppingMarketsPage data-id="element-29" />} data-id="element-28" />
          <Route path="/culture-history" element={<CultureHistoryPage data-id="element-31" />} data-id="element-30" />
          <Route path="/economy-innovation" element={<EconomyInnovationPage data-id="element-33" />} data-id="element-32" />
          <Route path="/hotels" element={<HotelsPage data-id="element-35" />} data-id="element-34" />
          <Route path="/landmarks" element={<LandmarksPage data-id="element-37" />} data-id="element-36" />
          <Route path="/festivals" element={<FestivalsPage data-id="element-39" />} data-id="element-38" />
          <Route path="/events" element={<EventsPage data-id="element-41" />} data-id="element-40" />
          <Route path="/events/:slug" element={<EventDetailPage data-id="element-43" />} data-id="element-42" />
        </Routes>
      </div>
    </Router>;
}
export { App };